import request from "@/utils/request";

export async function getDealerIntegrationsCount(dealerId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealer-integratons/count/${dealerId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function fetchDealerIntegrations(dealerId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealer-integratons/${dealerId}`, {
    method: "GET",
  });

  return result?.data ?? [];
}

export async function includeIntegrationToDealer(dealerId, integrationType, integrationId) {
  const data = {
    dealerId,
    type: integrationType,
    integrationId,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealer-integratons`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function excludeIntegrationFromDealer(integrationId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/dealer-integratons/${integrationId}`, {
    method: "DELETE",
  });

  return result?.data;
}
